// eslint-disable-next-line
import React from 'react';
import { Pager, IPagerProps } from '@cb/apricot-react';

export default function PagerWrapper(props: IPagerProps) {
  return <Pager {...props} />;
}
